import React from 'react';
import { Heart, Users, Leaf, TrendingUp, Check } from 'lucide-react';

export const CareAndSustainability = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-7xl mx-auto">
          {/* Icons Grid - Full Width */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Heart className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Produto Artesanal</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Users className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Produtores Locais</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Leaf className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Sustentável</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <TrendingUp className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Economia Colaborativa</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Check className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Não vai para o lixo</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Check className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Na geladeira por 1 ano ou + (depois replante e reuse)</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Check className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Visto todos os dias</span>
            </div>

            <div className="flex items-center gap-3 p-4 bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-xl border border-pink-100">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <Check className="h-5 w-5 text-white" />
              </div>
              <span className="text-sm font-semibold text-gray-700">Presente vivo</span>
            </div>
          </div>

          {/* Bottom Highlight */}
          <div className="mt-12 bg-gradient-to-r from-[#eb068c] to-[#c7056f] rounded-2xl p-8 md:p-10 text-white text-center shadow-xl">
            <h3 className="text-2xl md:text-3xl font-bold">
              Plantinha de Geladeira, um presente inesquecível 🌱
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};
